/**
 * Working Plant — punch card drawer.
 *
 * Opens/closes the header punch drawer (snippets/wp-punch-header.liquid,
 * mode 'drawer'), following the same pattern as the theme's cart drawer
 * (assets/dialog.js DialogComponent): body scroll-lock on open, animated
 * close via the .dialog-closing class, close on backdrop click / Esc /
 * close button. The punch drawer and the cart drawer are mutually
 * exclusive: opening one closes the other.
 */
(function () {
  if (window.__wpPunchDrawerInit) return;
  window.__wpPunchDrawerInit = true;

  var drawer = document.getElementById('wp-punch-drawer');
  if (!drawer) return;

  var previousScrollY = 0;
  var scrollLocked = false;
  var closing = false;

  function lockScroll() {
    if (scrollLocked) return;
    previousScrollY = window.scrollY;
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + previousScrollY + 'px';
    scrollLocked = true;
  }

  function unlockScroll() {
    if (!scrollLocked) return;
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, previousScrollY);
    scrollLocked = false;
  }

  function cartDialog() {
    return document.querySelector('cart-drawer-component dialog');
  }

  function closeCartDrawer() {
    var dialog = cartDialog();
    if (dialog && dialog.open) {
      var component = dialog.closest('cart-drawer-component');
      if (component && typeof component.close === 'function') {
        component.close();
      } else {
        dialog.close();
      }
    }
  }

  function openDrawer() {
    if (drawer.open) return;
    closeCartDrawer();
    lockScroll();
    drawer.showModal();
  }

  function finishClose() {
    if (drawer.open) drawer.close();
    drawer.classList.remove('dialog-closing');
    closing = false;
  }

  function closeDrawer() {
    if (!drawer.open || closing) return;
    closing = true;
    drawer.classList.add('dialog-closing');
    drawer.addEventListener('animationend', finishClose, { once: true });
    // Fallback in case the closing animation is disabled (reduced motion CSS etc.)
    setTimeout(finishClose, 450);
  }

  function hardCloseDrawer() {
    drawer.classList.remove('dialog-closing');
    closing = false;
    if (drawer.open) drawer.close();
    unlockScroll();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-wp-punch-open]');
    if (opener) {
      event.preventDefault();
      openDrawer();
      return;
    }
    var closer = event.target.closest('[data-wp-punch-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer();
    }
  });

  // If the cart is opened while the punch drawer is up, drop the punch
  // drawer instantly (capture phase, before the cart's own scroll-lock
  // bookkeeping runs) so only one drawer is ever open.
  document.addEventListener(
    'click',
    function (event) {
      if (drawer.open && event.target.closest('[data-testid="cart-drawer-trigger"]')) {
        hardCloseDrawer();
      }
    },
    true
  );

  // Same guard for the cart drawer's auto-open on cart add.
  var dialog = cartDialog();
  if (dialog && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (dialog.open && drawer.open) hardCloseDrawer();
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  drawer.addEventListener('click', function (event) {
    // Backdrop click: the dialog element itself is the click target.
    if (event.target === drawer) closeDrawer();
  });

  drawer.addEventListener('cancel', function (event) {
    // Esc: run the animated close instead of the native instant close.
    event.preventDefault();
    closeDrawer();
  });

  drawer.addEventListener('close', function () {
    drawer.classList.remove('dialog-closing');
    closing = false;
    unlockScroll();
  });
})();
